module.exports = __webpack_public_path__ + "img/partner4.2b50ca12.png";